import type { CSSObject, TypographyVariantsOptions } from '@mui/material/styles';
import { pxToRem } from 'minimal-shared/utils';

import { themeConfig } from '../themeConfig';

// ----------------------------------------------------------------------

/**
 * TypeScript (type definition and extension)
 * @to {@link file://./../extend-theme-types.d.ts}
 */
export type FontStyleExtend = {
  fontWeightSemiBold: CSSObject['fontWeight'];
  fontSecondaryFamily: CSSObject['fontFamily'];
};

// ----------------------------------------------------------------------

// `setFont` from minimal-shared wraps the whole value in one pair of quotes, which breaks a stack
// that already quotes its multi-word families, so the stack is passed through as authored.
const primaryFont = themeConfig.fontFamily.primary;
const secondaryFont = themeConfig.fontFamily.secondary;

export const typography: TypographyVariantsOptions = {
  fontFamily: primaryFont,
  fontSecondaryFamily: secondaryFont,
  fontWeightLight: '400',
  fontWeightRegular: '400',
  fontWeightMedium: '500',
  fontWeightSemiBold: '500',
  fontWeightBold: '500',
  h1: {
    fontWeight: 500,
    lineHeight: 1.2,
    fontSize: pxToRem(34),
    letterSpacing: '-0.03em',
  },
  h2: {
    fontWeight: 500,
    lineHeight: 1.25,
    fontSize: pxToRem(28),
    letterSpacing: '-0.025em',
  },
  h3: {
    fontWeight: 500,
    lineHeight: 1.3,
    fontSize: pxToRem(24),
    letterSpacing: '-0.02em',
  },
  h4: {
    fontWeight: 500,
    lineHeight: 1.4,
    fontSize: pxToRem(23),
    letterSpacing: '-0.02em',
  },
  h5: {
    fontWeight: 500,
    lineHeight: 1.4,
    fontSize: pxToRem(17),
    letterSpacing: '-0.01em',
  },
  h6: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    letterSpacing: '-0.005em',
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(13),
  },
  body1: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  body2: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(13),
  },
  caption: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(11),
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 400,
    lineHeight: 1.2,
    fontSize: pxToRem(13),
    textTransform: 'none',
  },
};
